import React, { useEffect } from "react"
import "../styles/app.scss"
import { LinksProp, Demo, ScrollToButton } from "@wp/ui"
import SEO from "./seo"
import { Helmet } from "react-helmet"
import magazineImg from "../img/Writers-Print (4).png"
import minimalImg from "../img/Writers-Print (3).png"
import lifestyleImg from "../img/Writers-Print (5).png"
import photographyImg from "../img/Writers-Print (2).png"
import Header from "./header"

type LayoutComponent = {
  title?: string
  withFooter?: boolean
}

const Layout: React.FC<LayoutComponent> = ({ children, title = "" }) => {
  // Check device type
  useEffect(() => {
    if (
      /iPhone|iPad|Android|Blackberry|iPod/.test(window.navigator.userAgent)
    ) {
      document.querySelector("body").classList.add("ismobile")
      document.querySelector("body").classList.remove("isnotmobile")
    } else {
      document.querySelector("body").classList.remove("ismobile")
      document.querySelector("body").classList.add("isnotmobile")
    }
    document.body.style.overflow = "unset"
    // document.cookie = "SameSite=None; promo_shown=1; Max-Age=2600000; Secure"
  }, [])

  const pageLinks: LinksProp[] = [
    { name: "Demos", to: "/#demos" },
    { name: "Features", to: "/#features" },
    { name: "FAQ", to: "/#faq" },
    { name: "Documentation", to: "/documentation" },
  ]

  return (
    <>
      <SEO title={title} />
      <Helmet
        link={[
          {
            rel: "stylesheet",
            href:
              "https://fonts.googleapis.com/css2?family=DM+Serif+Text&family=Lora:ital,wght@0,400;0,500;0,600;0,700;1,400;1,500;1,600;1,700&family=Open+Sans:ital,wght@0,300;0,400;0,600;0,700;0,800;1,300;1,400;1,600;1,700;1,800&display=swap",
          },
        ]}
      />
      <Header links={pageLinks} />
      {children}
      <Demo
        demos={[
          { img: minimalImg, url: "djf", title: "Minimal" },
          { img: photographyImg, url: "djf", title: "Photography" },
          { img: lifestyleImg, url: "djf", title: "Lifestyle" },
          { img: magazineImg, url: "djf", title: "Magazine" },
        ]}
      />
      <ScrollToButton />
    </>
  )
}

export default Layout
